import React, { useState, useEffect } from 'react';
import ComboSelector, { TipoClave } from './ComboSelector.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';
import { NombreEquipoCategoria } from '../../funciones/FuncionesEquipo.js';
import * as TipoEquipo from '../../constantes/TipoEquipo.js';

const CampoComboEquipoEditable = (props) => {
  const nombre = props.nombre;
  const valor = props.valor;
  const pais = props.pais;
  const categoria = props.categoria;
  const tipoEquipo = props.tipoEquipo;
  const anioTorneo = props.anioTorneo;
  const equiposExternos = props.equipos;
  const estilo = props.estilo;

  const [equipos, setEquipos] = useState(equiposExternos || []);
  const { isCargando, fetchData } = useGetListaURL();

  useEffect(() => {
    // Si ya se proporcionaron equipos, no cargar de nuevo
    if (equiposExternos && equiposExternos.length > 0) {
      setEquipos(equiposExternos);
      return;
    }

    // Cargar equipos según el tipo de torneo
    if (categoria) {
      let url = null;

      // Si es torneo de SELECCIONES, cargar todas las selecciones de la categoría
      if (tipoEquipo && tipoEquipo.codigo === TipoEquipo.SELECCION) {
        url = 'equipos?categoria=' + categoria.codigo + '&tipo=' + TipoEquipo.SELECCION;
      }
      // Si es torneo de CLUBES de un país, cargar equipos del país
      else if (pais && tipoEquipo && tipoEquipo.codigo === TipoEquipo.CLUB) {
        url =
          'paises/' +
          pais.id +
          '/equipos?categoria=' +
          categoria.codigo +
          '&tipo=' +
          TipoEquipo.CLUB;
        if (anioTorneo) {
          url += '&anio=' + anioTorneo;
        }
      }

      if (url) {
        fetchData(url, setEquipos);
      } else {
        setEquipos([]);
      }
    } else {
      setEquipos([]);
    }
  }, [pais, categoria, tipoEquipo, anioTorneo, fetchData, equiposExternos]);

  const onEquipoElegido = (equipoSeleccionado) => {
    props.onChange(nombre, equipoSeleccionado);
  };

  // Crear lista formateada para el combo
  const listaFormateada = equipos.map((equipo) => ({
    ...equipo,
    nombreFormateado: NombreEquipoCategoria(equipo.nombre, equipo.categoria, categoria),
  }));

  return (
    <ComboSelector
      estilo={estilo}
      lista={listaFormateada}
      valorActual={valor ? NombreEquipoCategoria(valor.nombre, valor.categoria, categoria) : ''}
      campoClave={TipoClave.ID}
      campoDescripcion="nombreFormateado"
      isCargando={isCargando}
      onItemElegido={onEquipoElegido}
    />
  );
};

export default CampoComboEquipoEditable;
